import { useMemo } from "react";
import { useSelector } from "react-redux";
import { type ApplicationState, createGetThrottleSelector } from "@ppb/tbd-store";

/**
 * Whether a throttle is active. Absent reads as off, and so does a throttles slice that has not arrived, so a
 * caller without throttle data falls back rather than throwing.
 */
export const useIsThrottleActive = (throttleId: string): boolean => {
  const getThrottle = useMemo(() => createGetThrottleSelector(), []);

  return useSelector((state: ApplicationState) => {
    const throttles = state.entities?.throttles;

    return !!throttles && !!getThrottle(throttles, throttleId)?.isActive;
  });
};
